import { graphql } from "../generated/gql";

export const GetLine = graphql(
  `
    query GetLine($filter: SearchableLinesFilterInput!) {
      searchAuthorizedLines(filter: $filter) {
        items {
          ...LineDetails
        }
      }
    }
  `
);
